<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11" v-if="project">
            <h1>Proyecto</h1>

            <div v-if="project.implementacion == 'Desarrollado'" class="form-group mt-4">
                <label for="idea_nombre">Tiempo de desarrollo</label>

                <input type="text" class="form-control" v-model="project.implementacion_tiempo" />
            </div>

            <div class="form-group mt-4">
                <label v-if="project.implementacion == 'Desarrollado'">Costo aproximado de desarrollo</label>
                <label v-else>Costo aproximado</label>

                <input type="text" class="form-control" v-model="project.implementacion_costo" />
            </div>

            <div class="form-group mt-4">
                <label for="idea_nombre">Costo aproximado de mantenimiento</label>

                <input type="text" class="form-control" v-model="project.implementacion_costo_mantenimiento" />
            </div>

            <div class="form-group mt-4">
                <label for="idea_nombre">Comentarios adicionales</label>

                <textarea class="form-control" v-model="project.implementacion_comentarios" />
            </div>

            <button class="btn w-100 btn-light btn-lg my-4" :disabled="disabled" @click="set">Guardar</button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            ...mapGetters(["getProject", "getUser"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        disabled: function () {
            if (this.project.implementacion == "Desarrollo") {
                return (
                    !this.project.implementacion_tiempo ||
                    !this.project.implementacion_costo ||
                    !this.project.implementacion_costo_mantenimiento ||
                    !this.project.implementacion_comentarios
                );
            }
            return (
                !this.project.implementacion_costo ||
                !this.project.implementacion_costo_mantenimiento ||
                !this.project.implementacion_comentarios
            );
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            axios
                .post("/api/funnel/proyectos", { project: this.project, user: this.getUser() })
                .then(() => {
                    router.push("ProjectFinish");
                })
                .catch(() => {
                    alert("Hubo un error al guardar el proyecto");
                });
        },
        ...mapActions(["setProject"]),
    },
};
</script>
